import React from "react";
import { useStyle } from "../../Screens/LTVacceptance-Confirmed/LoanAcceptance.styles";

interface TableRow {
  skuId: string;
  description: string;
  loanAmount2: string;
  interestRate: string;
  tenure: number;
  adminFee: string;
  transAndChannelFee: string;
  thirdPartyFee: string;
  loanApplicationCurrency: string;
}

interface MyTableProps {
  data: TableRow[];
  selectedSKUId: string[] | null;
  onCheckboxChange: (skuId: string) => void;
}

const MyTable: React.FC<MyTableProps> = ({ data }) => {
  const { classes } = useStyle();

  return (
    <table style={{ borderCollapse: "collapse", border: "none" }}>
      <thead>
        <tr>
          <th className={classes.thh}>SKU ID</th>
          <th className={classes.thh}>Description</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td className={classes.th}>{row.skuId}</td>
            <td className={classes.th}>{row.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MyTable;
